import React from 'react';
import {TextField, InputIconButton} from 'components/core';
import {InputAdornment} from '@material-ui/core';
import {AttachFile} from '@material-ui/icons';
import api from 'controllers/raymanAPI.js';
import HiddenFileInput from 'components/files/HiddenFileInput';

function ChatFooter({operationID, className})
{
    const [sendText, setSendText] = React.useState("");
    const fileInput = React.useRef();

    function sendMessage()
    {
        api.operations.messages.post(operationID, 2002, sendText);
        setSendText("");
    }    

    function keyPress(evt)
    {
        if(evt.charCode === 13 && sendText)
        {
            sendMessage();
        }
    }
    
    const handleAttachClick = React.useCallback(() =>
    {
        fileInput.current.click();
    }, [fileInput]);

    return <div className={className}>
            <TextField 
            placeholder="Escribe algo"
            value={sendText}
            onChange={(evt)=>setSendText(evt.target.value)}
            onKeyPress={keyPress}
            endAdornment={
                <InputAdornment position="end">
                  <InputIconButton
                    onClick={handleAttachClick}
                  >
                    <AttachFile />
                  </InputIconButton>
                </InputAdornment>
              }
            />
        <HiddenFileInput ref={fileInput} apiFileEndpoint={api.operations.files} apiRequestParams={[operationID]}/>
    </div>
}


export default ChatFooter;